import React, { useState } from 'react';
import './forgotpassword.css';

const ForgotPassword = ({ onClose }) => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle');
    const [error, setError] = useState(null);
    const API_URL = process.env.REACT_APP_API_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('loading');
        try {
            const response = await fetch(`${API_URL}/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });
                if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'Reset request failed');
            }
            setStatus('success');
        } catch (err) {
            setError(err.message);
            setStatus('error');
        }
    };
    
    
    return (
        <div className="popup-container">
            <div className="popup">
                <button className='closeBtn' onClick={onClose}>
                    <i className="fa-solid fa-x" />
                </button>
                <div className="popupcontent">
                    <h2 style={{fontWeight:'400'}}>Forgot your Password ?</h2>
                    <p style={{fontSize:'0.9rem', fontWeight:'350', padding:'0.5rem'}}>
                        Enter the email address you used to sign up
                        and we'll send you instructions to reset
                        your password.
                    </p>
                    <form style={{marginTop:'1rem'}} onSubmit={handleSubmit}>
                        <input 
                            type='email' 
                            className='forgotforminput' 
                            placeholder='Email' 
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required 
                        />
                        <input 
                            type='submit' 
                            className='forgotforminput' 
                            value={status === 'loading' ? 'Sending...' : 'Send'} 
                            style={{
                                backgroundColor:'#09CE78', 
                                color:'white', 
                                paddingTop:'0.6rem',
                                paddingBottom:'0.6rem', 
                                marginTop:'1rem',
                                cursor: status === 'loading' ? 'wait' : 'pointer'
                            }}
                            disabled={status === 'loading'}
                        />
                        {status === 'success' && (
                            <p style={{color: 'green', marginTop: '1rem'}}>
                                Reset instructions sent to your email! please check your spam folder
                            </p>
                        )}
                        {error && (
                            <p style={{color: 'red', marginTop: '1rem'}}>
                                {error}
                            </p>
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;